export type PcMonitorSort = 'gap' | 'newest' | 'price_asc';

interface CandidateFilterBarProps {
  includeRejected: boolean;
  onIncludeRejectedChange: (value: boolean) => void;
  counts: { candidates: number; rejected: number };
  sort: PcMonitorSort;
  onSortChange: (sort: PcMonitorSort) => void;
}

const SORT_OPTIONS: { value: PcMonitorSort; label: string }[] = [
  { value: 'gap', label: 'Value gap (biggest first)' },
  { value: 'newest', label: 'Newest posted' },
  { value: 'price_asc', label: 'Asking price (low to high)' },
];

/**
 * Read-only filters: the rejected toggle (default off — qualifying and
 * needs-confirmation candidates only) and the sort selector. Nothing here
 * mutates anything.
 */
export default function CandidateFilterBar({
  includeRejected,
  onIncludeRejectedChange,
  counts,
  sort,
  onSortChange,
}: CandidateFilterBarProps) {
  return (
    <div className="flex items-center gap-4 flex-wrap">
      <label className="inline-flex items-center gap-2 text-sm text-gray-700 cursor-pointer select-none">
        <input
          type="checkbox"
          checked={includeRejected}
          onChange={(e) => onIncludeRejectedChange(e.target.checked)}
          className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
        />
        Include rejected
        <span className="text-xs text-gray-400">({counts.rejected})</span>
      </label>
      <label className="inline-flex items-center gap-2 text-sm text-gray-700">
        <span className="text-gray-500">Sort</span>
        <select
          value={sort}
          onChange={(e) => onSortChange(e.target.value as PcMonitorSort)}
          className="rounded-md border border-gray-300 text-sm py-1 pl-2 pr-6 bg-white focus:outline-none focus:ring-1 focus:ring-blue-500"
        >
          {SORT_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      <span className="text-xs text-gray-400 ml-auto">
        {counts.candidates} candidate{counts.candidates === 1 ? '' : 's'}
        {includeRejected ? ` + ${counts.rejected} rejected` : ''}
      </span>
    </div>
  );
}
